// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3BGcg","content":"LayoutSettings_content__1E-3r"};